import script from "./HeatMap.vue?vue&type=script&setup=true&lang=js"
export * from "./HeatMap.vue?vue&type=script&setup=true&lang=js"

import "./HeatMap.vue?vue&type=style&index=0&id=44a0dac8&lang=css"

const __exports__ = script;

export default __exports__